export const API_URL = process.env.REACT_APP_API_URL;
export const GOOGLE_AUTH_CLIENT_ID =
  process.env.REACT_APP_GOOGLE_AUTH_CLIENT_ID;
export const HOSTED_DOMAIN = process.env.REACT_APP_HOSTED_DOMAIN;
export const POLL_SESSION_CREATED_INTERVAL_MS = 5000;
export const INITIAL_SESSION_CREATED_WAIT_MS = 1500;
export const ELASTIC_SERVER_URL = process.env.REACT_APP_ELASTIC_SERVER_URL;
export const ELASTIC_APM_ACTIVE = process.env.REACT_APP_ELASTIC_APM_ACTIVE;
export const REACT_APP_VERSION = process.env.REACT_APP_VERSION;
export const MAX_IMAGE_SIZE = 250;

export const CLEAN_IMAGE_STATE = "clean";
export const UNCLEAN_IMAGE_STATE = "unclean";
export const NEEDS_REVIEW_STATUS = "needs-review";
export const PRE_CLEAN_REVIEW_STATUS = "pre-clean";
export const FINALIZED_REVIEW_STATUS = "finalized";
export const MERGE_IMAGE_STATE = "merge";
export const REMOVE_NOISY_IMAGE_STATE = "remove_noisy";
export const REMOVE_NEAR_DUPLICATE_IMAGE_STATE = "remove_near_duplicate";

export const DEFAULT_STATE_TRANSITIONS = {
  [CLEAN_IMAGE_STATE]: UNCLEAN_IMAGE_STATE,
  [UNCLEAN_IMAGE_STATE]: CLEAN_IMAGE_STATE,
  [MERGE_IMAGE_STATE]: UNCLEAN_IMAGE_STATE,
  [REMOVE_NOISY_IMAGE_STATE]: CLEAN_IMAGE_STATE,
  [REMOVE_NEAR_DUPLICATE_IMAGE_STATE]: CLEAN_IMAGE_STATE,
};

export const GLOBAL_HTTP_ERROR_CODES = [401, 403, 404, 500];
